﻿import React from 'react';

import { ComponentConfigsMap } from '../forms/ComponentsMap';

import { IExternalLayersState } from '../models/ChartModels';
import ExternalLayerSelect from '../components/externalLayers/ExternalLayerSelect';
import { ExternalLayersStore } from '../stores/ExternalLayersStore';

/**
 * Describes components used to create a UI for External layers
 */
export const externalLayersStateConfig = (externalLayersStore: ExternalLayersStore): ComponentConfigsMap<IExternalLayersState> => {
    return {
        selectedLayerId: {
            hidden: state => !state.layers?.length,
            label: "External",
            component: state => <ExternalLayerSelect layers={state.layers ?? []} showSettingsButton={state.enableLayerAdmin} externalLayersStore={externalLayersStore} />
        }
    }
}